// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"a5fca407","453":"616d8571","455":"968f8e03"}[chunkId] + ".chunk.js";
};